import React, {useState, useEffect} from 'react';
import {withRouter, useParams} from "react-router-dom";
import {connect} from "react-redux";
import {formatErrors, userDiseases, userDiseasesConfirmed, months} from "../../constants";
import {toast} from "react-toastify";
import {clientsGetByCodeAction, clientUpdateByCodeAction} from "../../actions/clientAction";
import '../../main.css';
import '../../responsive.css';
import {ProgressSubmit} from "../../utils/progress/ProgressSubmit";
import {InputInfo} from "../../utils/input/InputInfo";
import {InputCheckboxInfo} from "../../utils/checkbox/InputCheckboxInfo";

function Health(props) {
  const {code} = useParams();
  const {history, getClient} = props;
  const [item, setItem] = useState(null);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [done, setDone] = useState(0);
  useEffect(() => {
    if (!code) {
      history.push('/');
    }
    getClient(code).then((client) => {
      let birthday = client.birthday.split('T')[0];
      if (birthday.split('-')[0] === '0001') {
        birthday = '';
      }
      setForm({
        city: client.city || '',
        birthday: birthday,
        children: client.children || '',
        man_height: client.man_height || '',
        weight: client.weight || '',
        weight_target: client.weight_target || '',
        weight_biggest: client.weight_biggest || '',
        diseases: client.diseases ? client.diseases.split(',') : [],
        diseases_kidneys: client.diseases_kidneys || '',
        diseases_gynecology: client.diseases_gynecology || '',
        diseases_thyroid: client.diseases_thyroid || '',
        diseases_cardio: client.diseases_cardio || '',
        diseases_other: client.diseases_other || '',
        allergies: client.allergies || '',
        recent_diseases: client.recent_diseases || '',
        antibiotic: client.antibiotic || '',
        recent_diets: client.recent_diets || '',
        recent_diet_programs: client.recent_diet_programs || '',
        birthday_day: client.birthday_day || '',
        birthday_month: client.birthday_month || '',
        birthday_year: client.birthday_year || ''
      });
      setItem(client);
    }).catch((err) => {
      console.log(err)
      history.push('/');
    });
  }, [code, history, getClient]);

  useEffect(() => {
    setDone(Object.keys(form).reduce((res, i) => {
      if ((i === 'diseases' && form[i].length > 0) || (i !== 'diseases' && ('' + form[i]).length > 0)) {
        res += 1;
      }
      return res;
    }, 0))
  }, [form]);

  const handleChangeText = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
  };

  const handleChangeNumber = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value === '' ? '' : value * 1}
    });
  };

  const handleDiseaseSelected = (item, checked) => {
    setForm((form) => {
      return {...form, diseases: checked ? [item].concat(form.diseases) : form.diseases.filter(i => i !== item)}
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return false;
    }
    let errs = {};
    const values = {...form};
    ['man_height', 'weight', 'weight_target', 'weight_biggest'].forEach((k) => {
      if (isNaN(1 * values[k])) {
        errs[k] = true;
        values[k] = 0;
      } else {
        values[k] = values[k] * 1;
      }
    });

    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }

    if (item.weight && form.weight !== item.weight) {
      values['weight_prev'] = item.weight;
    }
    values['diseases'] = values['diseases'].join(',');

    setLoading(true);
    props.updateClient(code, values).then(() => {
      setLoading(false);
      toast.success('Анкета отправлена', {position: toast.POSITION.BOTTOM_RIGHT});
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const getMonthList = monthslist => {
    let content = [];
    for (let i = 0; i < 12; i++) {
      content.push(<option key={i+1} value={i+1}>{months[i]}</option>);
    }
    return content;
  };

  const getDaysList = dayslist => {
    let content = [];
    for (let i = 0; i < 31; i++) {
      content.push(<option key={i+1} value={i+1}>{i+1}</option>);
    }
    return content;
  };

  const getYearList = yearslist => {
    let content = [];
    for (let i = 1950; i < 2023; i++) {
        content.push(<option key={i} value={i}>{i}</option>);
    }
    return content;
  };

  useEffect(() => {
    document.title = 'Курс метаболического похудения';
    document.querySelector('meta[name="description"]').content = 'Анкета Здоровья';
    document.querySelector('link[rel="icon"]').href = 'https://vesbalans.ru/instagram/assets/img/favicon.png';
    document.querySelector('link[rel="shortcut icon"]').href = 'https://vesbalans.ru/instagram/assets/img/favicon.png';
    document.body.className = "page-info";
    return () => {
      document.body.className = "";
      document.title = 'Куратор';
      document.querySelector('meta[name="description"]').content = 'Панель оператора';
      document.querySelector('link[rel="icon"]').href = '/favicon.ico';
      document.querySelector('link[rel="shortcut icon"]').href = '/favicon.ico';
    }
  }, []);

  return <header>
    <ProgressSubmit all={14} done={done} onSubmit={handleSubmit}/>

    {item && <div className="container">
      <div className="info">
        <div className="info__title">
          <p className="title">Анкета здоровья</p>
          <p className="valid">* поля обязательны для заполнения</p>
        </div>
        <form className="info__form" noValidate onSubmit={handleSubmit}>
          <InputInfo type="text"
                     title="Населенный пункт где вы живете? (город, страна)"
                     name="city"
                     value={form.city}
                     error={errors.city || false}
                     disabled={loading}
                     onChange={handleChangeText}/>
                     
          <div className="info__form_input">
            <p>Дата рождения</p>
            <select className="info__form_input_select margin10" name="birthday_day"
                title="День рождения"
                value={form.birthday_day}
                error={errors.birthday_day || false}
                disabled={loading}
                onChange={handleChangeText}>
                <option value="">День</option>
                {getDaysList()}
            </select>
            <select className="info__form_input_select margin10" name="birthday_month"
                title="Месяц рождения"
                value={form.birthday_month || 1}
                error={errors.birthday_month || false}
                disabled={loading}
                onChange={handleChangeText}>
                {getMonthList()}
            </select>
            <select className="info__form_input_select" name="birthday_year"
                title="Год рождения"
                value={form.birthday_year || 1990}
                error={errors.birthday_year || false}
                disabled={loading}
                onChange={handleChangeText}>
                {getYearList()}
            </select>
          </div>

          <InputInfo type="text"
                     title="Дети"
                     name="children"
                     value={form.children}
                     error={errors.children || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="number"
                     title="Ваш рост"
                     name="man_height"
                     value={form.man_height}
                     error={errors.man_height || false}
                     disabled={loading}
                     onChange={handleChangeNumber}/>

          <InputInfo type="number"
                     title="Вес на данный момент"
                     name="weight"
                     value={form.weight}
                     error={errors.weight || false}
                     disabled={loading}
                     onChange={handleChangeNumber}/>

          <InputInfo type="number"
                     title="Мой целевой вес"
                     name="weight_target"
                     value={form.weight_target}
                     error={errors.weight_target || false}
                     disabled={loading}
                     onChange={handleChangeNumber}/>

          <InputInfo type="number"
                     title="Самый большой вес"
                     name="weight_biggest"
                     value={form.weight_biggest}
                     error={errors.weight_biggest || false}
                     disabled={loading}
                     onChange={handleChangeNumber}/>

          <InputInfo type="text"
                     title="Диеты за последние 2-3 месяца"
                     name="recent_diets"
                     value={form.recent_diets}
                     error={errors.recent_diets || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title="Аллергия на продукты питания"
                     name="allergies"
                     value={form.allergies}
                     error={errors.allergies || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title="Прием антибиотиков (6 Месяцев)"
                     name="antibiotic"
                     value={form.antibiotic}
                     error={errors.antibiotic || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title="Кол-во ОРВИ и вирусных заболеваний за последний год"
                     name="recent_diseases"
                     value={form.recent_diseases}
                     error={errors.recent_diseases || false}
                     disabled={loading}
                     onChange={handleChangeText}/>


          <div className="info__form_radio">
            <p>История Здоровья</p>
            <div className="check-inputs">
              {
                userDiseases.map((i, k) => <InputCheckboxInfo key={k}
                                                              title={i + (userDiseasesConfirmed.indexOf(k) > -1 ? ' (если диагноз поставлен врачом)' : '')}
                                                              disabled={loading}
                                                              name={"diseases_" + k}
                                                              checked={form.diseases.indexOf(i) > -1}
                                                              onChange={(name, checked) => handleDiseaseSelected(i, checked)} />)
              }
            </div>
          </div>

          <InputInfo type="text"
                     title="Другие заболевания"
                     name="diseases_other"
                     value={form.diseases_other}
                     error={errors.diseases_other || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title="Какие программы похудения вы проходили прежде?"
                     name="recent_diet_programs"
                     className="bottom"
                     value={form.recent_diet_programs}
                     error={errors.recent_diet_programs || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <button className="info__form_btn">Отправить</button>
        </form>
      </div>
    </div>}
  </header>;
}

const mapDispatchToProps = (dispatch) => {
  return {
    getClient(code) {
      return dispatch(clientsGetByCodeAction(code));
    },
    updateClient(code, data) {
      return dispatch(clientUpdateByCodeAction(code, data));
    }
  }
};

export default connect(null, mapDispatchToProps)(withRouter(Health))
